import type {KeyTextField} from '@prismicio/client'

export const SlideHeadlineSection = ({tag, title}: {tag: KeyTextField; title: string}) => (
  <div className="flex max-w-[416px] flex-col gap-3">
    <p className="text-body-xs-caps font-semibold text-green-neon">{tag}</p>
    <h2 className="text-h4 font-medium text-moss-white max-md:leading-[28px] md:text-32 md:leading-[38px]">{title}</h2>
  </div>
)
